import React, { useState } from "react";
import { Row, Col, Form, Button, Container } from "react-bootstrap";
import { round } from "lodash";

function PeggedSalaryCalculator() {
  const [dollarRate, setDollarRate] = useState(300);
  const [basic, setBasic] = useState(2100 * 200);
  const [requested, setRequested] = useState(false);
  const [calObj, setCalObj] = useState({
    usdBasic: 0,
    basic: 0,
    epfDeductionsEmployee: 0,
    takeHome: 0,
    totalTax: 0,
    stampDuty: 0,
    internetAllowance: 0,
    totalInLkr: 0,
  });

  const $ = (num) => {
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    return formatter.format(num);
  };

  const rs = (num) => {
    var formatter = new Intl.NumberFormat("si-LK", {
      style: "currency",
      currency: "LKR",
    });
    return formatter.format(num);
  };

  const submitHandler = () => {
    const peggedRate = 200;
    const usdBasic = basic / peggedRate;
    const slabs = [
      { limit: 1200000, rate: 0 },
      { limit: 500000, rate: 0.06 },
      { limit: 500000, rate: 0.12 },
      { limit: 500000, rate: 0.18 },
      { limit: 500000, rate: 0.24 },
      { limit: 500000, rate: 0.3 },
    ];
    const epfRate = 8 / 100;
    const internetAllowance = 2000;
    const stampDuty = 50;

    const basicInUsd = round(basic / peggedRate, 2);
    const totalInLkr = basicInUsd * dollarRate + internetAllowance;

    let totalTax = 0.0;
    let remainingSalary = totalInLkr * 12;

    for (let i = 0; i < slabs.length; i++) {
      const { limit, rate } = slabs[i];

      if (remainingSalary > 0) {
        const taxableAmount = Math.min(limit, remainingSalary);
        totalTax += (taxableAmount * rate) / 12;
        remainingSalary -= taxableAmount;
      } else {
        break;
      }
    }
    if (remainingSalary > 0) {
      totalTax += (remainingSalary * 0.36) / 12;
    }

    const epfDeductionsEmployee = round(basic * epfRate, 2);

    const takeHome = totalInLkr - epfDeductionsEmployee - totalTax - stampDuty;

    setCalObj({
      ...calObj,
      usdBasic,
      basic,
      epfDeductionsEmployee,
      takeHome,
      totalTax,
      stampDuty,
      internetAllowance,
      totalInLkr,
    });
    setRequested(true);
  };

  return (
    <>
      <Container>
        <h3>Pegged Salary Calculator</h3>
        <Row className="my-2">
          <Col>
            <Form.Label>Basic Salary (LKR) </Form.Label>
            <Form.Control
              type="number"
              value={basic}
              onChange={(e) => {
                setBasic(e.target.value);
                setRequested(false);
              }}
              placeholder="Enter Basic Salary"
            />
          </Col>
        </Row>
        <Row className="my-2">
          <Col>
            <Form.Label>Dollar Rate</Form.Label>
            <Form.Control
              key={"dollar-rate"}
              type="number"
              value={dollarRate}
              onChange={(e) => {
                setDollarRate(e.target.value);
                setRequested(false);
              }}
              placeholder="Enter Dollar Rate"
            />
          </Col>
        </Row>
        <Button className="my-3" onClick={submitHandler}>
          Create Pay Sheet
        </Button>
      </Container>
      {requested && (
        <Container>
          <hr />
          <Row>
            <Col className="font-weight-bold">Basic in LKR</Col>
            <Col>:</Col>
            <Col className="text-end">{rs(calObj.basic)}</Col>
          </Row>
          <Row>
            <Col className="font-weight-bold">Basic in USD</Col>
            <Col>:</Col>
            <Col className="text-end">{$(calObj.usdBasic)}</Col>
          </Row>
          <hr />
          <Row>
            <Col className="font-weight-bold">Internet Bill</Col>
            <Col>:</Col>
            <Col className="text-end">{"+" + rs(calObj.internetAllowance)}</Col>
          </Row>
          <Row>
            <Col className="font-weight-bold">Total Earning</Col>
            <Col>:</Col>
            <Col className="text-end">{rs(calObj.totalInLkr)}</Col>
          </Row>
          <Row>
            <Col className="font-weight-bold">APIT</Col>
            <Col>:</Col>
            <Col className="text-end">{"-" + rs(calObj.totalTax)}</Col>
          </Row>
          <Row>
            <Col className="font-weight-bold">Stamp Duty</Col>
            <Col>:</Col>
            <Col className="text-end">{"-" + rs(calObj.stampDuty)}</Col>
          </Row>
          <Row>
            <Col className="font-weight-bold">EPF (Employee) (8%)</Col>
            <Col>:</Col>
            <Col className="text-end">
              {"-" + rs(calObj.epfDeductionsEmployee)}
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="font-weight-bold">
              <strong>Take Home</strong>
            </Col>
            <Col>
              <strong>:</strong>
            </Col>
            <Col className="text-end">
              <strong>{rs(calObj.takeHome)}</strong>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default PeggedSalaryCalculator;
